import { Box, Stack } from '@mui/material'
import { Container, Typography } from '@evocolabs/orkaui'
import I3years64 from '@evocolabs/icons/lib/I3years64'
import I45days64 from '@evocolabs/icons/lib/I45days64'
import { SectionTitle } from '../title'
import theme from '@/src/theme'

const data = {
  title: `You've Got Nothing\nto Worry about`,
  itemData: [
    {
      icon: <I3years64 />,
      title: '3-year warranty',
      content: `Enjoy unlimited free consultations with Orka's Professionals with no extra cost.`
    },
    {
      icon: (
        <I45days64
          replaceFillColor={[
            ['#F2E9DA', 'transparent'],
            ['#30445E', 'white']
          ]}
          replaceStrokeColor={[['#30445E', 'white']]}
        />
      ),
      title: '45-Day Money Back Guarantee',
      content: `The full OrkaCare service is included during Orka Two's 45-day risk-free trial.`
    }
  ]
}
const Warranty = (): JSX.Element => {
  return (
    <Box
      width="100%"
      bgcolor={theme.palette.primary[700]}
      mt={{ xs: 10, dl: 15 }}
    >
      <Container
        sx={{
          paddingY: { xs: 8, dl: 10 }
        }}
      >
        <Stack
          direction={{ xs: 'column', dl: 'row' }}
          spacing={{ xs: 5, dl: 8 }}
          alignItems={{ xs: 'center', sm: 'flex-start', dl: 'center' }}
          style={{
            color: 'white',
            whiteSpace: 'pre-wrap'
          }}
        >
          <SectionTitle
            color="white"
            textAlign={{ xs: 'center', sm: 'left' }}
            minWidth={{ dl: '410px' }}
          >
            {data.title}
          </SectionTitle>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={5}>
            {data.itemData.map(({ icon, title, content }) => (
              <Stack
                flex="1 1 0"
                spacing={1}
                key={title}
                alignItems={{ xs: 'center', sm: 'flex-start' }}
              >
                {icon}
                <Typography variant="T2">{title}</Typography>
                <Typography
                  variant="body3"
                  textAlign={{ xs: 'center', sm: 'left' }}
                >
                  {content}
                </Typography>
              </Stack>
            ))}
          </Stack>
        </Stack>
      </Container>
    </Box>
  )
}

export default Warranty
